import { useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

export default function GalleryPage() {

  const images = [
    "/images/gallery/gallery1.jpg",
    "/images/gallery/gallery2.jpg",
    "/images/gallery/gallery3.jpg",
    "/images/gallery/gallery4.jpg",
    "/images/gallery/gallery5.jpg",
    "/images/gallery/gallery6.jpg",
    "/images/gallery/gallery7.jpg",
    "/images/gallery/gallery8.jpg",
    "/images/gallery/gallery9.jpg"
  ];

  const [index, setIndex] = useState(-1);

  return (

    <MainLayout>

      <section className="pt-40 pb-32 px-6 bg-[#f8f5f1]">

        <div className="max-w-7xl mx-auto">

          {/* TITOLO */}

          <div className="text-center mb-20">

            <h1 className="text-5xl font-serif mb-4">
              Gallery
            </h1>

            <p className="text-gray-500">
              Gli ambienti e i trattamenti di Alkimya Estetica
            </p>

          </div>


          {/* MASONRY GRID */}

          <div className="columns-1 md:columns-3 gap-8 space-y-8">

            {images.map((img, i) => (

              <div
                key={i}
                className="overflow-hidden rounded-2xl cursor-pointer break-inside-avoid"
                onClick={() => setIndex(i)}
              >

                <img
                  src={img}
                  className="w-full object-cover hover:scale-110 transition duration-700"
                />

              </div>

            ))}

          </div>

        </div>

      </section>


      {/* LIGHTBOX */}

      <Lightbox
        open={index >= 0}
        close={() => setIndex(-1)}
        slides={images.map((src) => ({ src }))}
        index={index}
      />

    </MainLayout>

  );
}